import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Insurance = 'Insurance',
}

export const queryKeys = {
  insurance: (clientId: string) => [QueryFeature.Profile, QueryKey.Insurance, clientId],
};
